import { render, staticRenderFns } from "./TbsSection.vue?vue&type=template&id=083603a0&"
import script from "./TbsSection.vue?vue&type=script&lang=js&"
export * from "./TbsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports